import { ControlReduxRawValue } from "../types";

/**
 * Společné parametry předávané do všech validačních funkcí z `validationFunctions.ts`.
 */
interface ICommonParams<T extends ControlReduxRawValue> {
    /**
     * Hodnota, která je předmětem validace.
     * Za `T` by měl být dosazen konkrétní typ, který je danou konkrétní validační funkcí podporován. Např. `string`.
     */
    readonly value: T;
}

/**
 * Vstupní parametry pro funkci `isMaxLengthValid`.
 */
export interface IValidateMaxLengthParams extends ICommonParams<string | undefined | null> {
    /**
     * Maximální délka, vůči které `isMaxLengthValid` bude validovat.
     */
    readonly maxLength: number;
}

/**
 * Vstupní parametry pro funkci `isRegexValid`.
 */
export interface IValidateRegexParams extends ICommonParams<string | undefined | null> {
    /**
     * Regulární výraz, vůči kterému `isRegexValid` bude validovat.
     */
    readonly regex: RegExp;
}

/**
 * Vstupní parametry pro funkci `isNumbersOnlyValid`.
 */
export interface IIsNumbersOnlyValidParams extends ICommonParams<string | undefined | null> {
    // Schválně prázdné. "isNumbersOnlyValid" nemá žádné extra parametry.
}

/**
 * Vstupní parametry pro funkci `charsDeleted`.
 */
export interface IValidateCharsDeletedParams extends ICommonParams<string | undefined | null> {
    /**
     * Protějšek, vůči kterému se bude délka `value` validovat.
     */
    readonly targetValue: string | undefined | null;
}

/**
 * Vstupní parametry pro funkci `isNumberCharactersOnlyValid`.
 */
export interface IIsNumberCharactersOnlyValidParams extends ICommonParams<string> {
    readonly isInteger: boolean;
}

/**
 * Vstupní parametry pro funkci `isMinValueValid` a `isMinValueBigNumberValid`.
 */
export interface IValidateMinValueParams extends ICommonParams<string> {
    readonly isBigNumber: boolean;
    readonly minValue: number;
}

/**
 * Vstupní parametry pro funkci `isMaxValueValid` a `isMaxValueBigNumberValid`.
 */
export interface IValidateMaxValueParams extends ICommonParams<string> {
    readonly isBigNumber: boolean;
    readonly maxValue: number;
}
